/**
 * User: elanh
 * Date: 2/21/13
 */

define(function (require) {
    "use strict";

    var _ = require("underscore");
    var Marionette = require("marionette");
    var CONST = require("const");
    var LiveEngageUserBarController = require("controllers/LiveEngageUserBarController");
    var LiveEngageLayout = require("layouts/LiveEngageLayout");
    var TopLevelMenuItemModel = require("models/top-level-menu/TopLevelMenuItemModel");
    var TrayMenuItemModel = require("models/TrayMenuItemModel");
    var DefaultDatabar = require("views/DefaultDatabar");
    var Bubble = require("ui/bubble/Bubble");
    var Button = require("ui/button/Button");
    var UpgradeAccountView = require("views/UpgradeAccountView");
    var LEConfig = require("assets/config/le-env-conf");
    var workAreaTemplate = require("templates/workAreaItem.tmpl");
    var workAreaNoLEClassTemplate = require("templates/workAreaItemNoLEClass.tmpl");
    var connectionTemplate = require("templates/connectionItem.tmpl");
    var reportingTemplate = require("templates/reportingItem.tmpl");
    var personalizationTemplate = require("templates/personalizationItem.tmpl");
    var LEResourceResolver = require("leResourceResolver");

    var templates = {
        workAreaItem: workAreaTemplate,
        workAreaItemNoLEClass: workAreaNoLEClassTemplate,
        connectionItem: connectionTemplate,
        reportingItem: reportingTemplate,
        personalizationItem: personalizationTemplate
    };
    var interactionTemplates = [
        "workAreaItem",
        "workAreaItemNoLEClass"
    ];

    /*
     this controller is responsible for controlling the different components of the LiveEngage application
     on start, it displays the LiveEngage layout and sets all its sub-regions
     */
    var LiveEngageLayoutController = Marionette.Controller.extend({
        moduleRegions: {},
        initialize: function (options) {
            this.LE = options.application;
            this._initRegions();
            this._initMembers();
        },
        _initRegions: function () {
            _.each(this.LE.sessionManager.getPersonas(), function (persona) {
                this._initPersonaModules(persona);
            }, this);

            // Create the container for the default Top bar if needed
            var reporting = this.LE.moduleManager.resolveModuleNameById("reporting");
            if (!this.moduleRegions[reporting.moduleName]) {
                this._parseStaticReportingRegion(reporting);
            }
        },
        _initPersonaModules: function (persona) {
            _.each(this.LE.moduleManager.resolveModules(persona), function (value, key, modules) {
                this._initModuleConfig(value);
            }, this);
        },
        _initModuleConfig: function (value) {
            var persona = this.LE.moduleManager.resolvePersona(value);
            var config = this.LE.moduleManager.resolveModuleConfig(persona);

            if (config.regionId && config.template && config.container) {
                this._initModuleRegion(persona, value, config);
            }
        },
        _initModuleRegion: function (persona, value, config) {
            this._parseModuleRegionBasicAttributes(persona, value, config);
            this._parseModuleRegionLayoutingAttributes(value, config);
            this._parseModuleRegionSwitcherAttributes(value, config);
            this._parseModuleRegionNotifierAttributes(value, config);
        },
        _parseModuleRegionBasicAttributes: function (persona, value, config) {
            this.moduleRegions[value] = {};
            this.moduleRegions[value].persona = persona;
            this.moduleRegions[value].config = config;
        },
        _parseModuleRegionLayoutingAttributes: function (value, config) {
            this.moduleRegions[value].element = $(templates[config.template]({
                name: config.regionId,
                transition: (config.transition ? "interaction-area-transition " : "")
            }));
            this.moduleRegions[value].container = config.container;
            this.moduleRegions[value].static = (-1 === _.indexOf(interactionTemplates, config.template)); // Represents a module which is not located in the interaction area
            this.moduleRegions[value].transition = config.transition;
            this.moduleRegions[value].unique = this._parseModuleRegionUniqueClass(value, config);
        },
        _parseModuleRegionUniqueClass: function (value, config) {
            var classList = this.moduleRegions[value].element.attr("class").split(/\s+/);
            var i = 0;

            for (; i < classList.length; i++) {
                if (0 === classList[i].indexOf(config.regionId)) {
                    return classList[i];
                }
            }
        },
        _parseModuleRegionSwitcherAttributes: function (value, config) {
            if (config.switcher && 0 < config.switcher.index && config.switcher.control) {
                this.moduleRegions[value].switcherControl = config.switcher.control;
                this.moduleRegions[value].switcherIndex = config.switcher.index;
            }
        },
        _parseModuleRegionNotifierAttributes: function (value, config) {
            if (config.notifierContainer) {
                this.moduleRegions[value].notifierContainer = config.notifierContainer;
            }
        },
        _parseStaticReportingRegion: function (reporting) {
            this.moduleRegions[reporting.moduleName] = {};
            this.moduleRegions[reporting.moduleName].container = reporting.container;
            this.moduleRegions[reporting.moduleName].element = $(templates[reporting.template]({
                name: reporting.regionId,
                transition: (reporting.transition ? "interaction-area-transition " : "")
            }));
        },
        _initMembers: function () {
            // Create the application main layout object
            this.mainLayout = new LiveEngageLayout({
                application: this.LE,
                moduleRegions: this.moduleRegions
            });
            this.liveEngageUserBarController = new LiveEngageUserBarController({
                application: this.LE,
                moduleRegions: this.moduleRegions
            });
        },
        start: function () {
            var that = this;
            //the context of the callback will be this (this controller)
            this.listenTo(this.mainLayout, "render", function () {
                //triggerEventsthrow new Error("KKK");
                //when the layout is rendered, we'll setup the inner regions
                this._setRegions();
                this.liveEngageUserBarController.show({containerRegion: this.mainLayout["user-bar"]});

                if (!this.mainLayout.getTopBarView()) {
                    this.mainLayout.setTopBarView(new DefaultDatabar());
                }
            });
            this.LE.vent.on("module:active", function (options) {
                if (options.moduleName && this.moduleRegions[options.moduleName] && this.moduleRegions[options.moduleName].unique) {
                    var region = this.moduleRegions[options.moduleName];
                    this.mainLayout.setViewedWorkarea("." + region.unique);
                    _.each(this.moduleRegions, function (region, key) {
                        if (key != options.moduleName && region.switcherControl) {
                            this.LE.context.set(key + ".isVisible", false);
                        }
                    }, this);

                    this.LE.context.set(options.moduleName + ".isVisible", true);
                    // resolve the persona and set it into the context object, this way all the relevant modules
                    var resolvedPersona = this.LE.moduleManager.resolvePersona(options.moduleName);
                    this.LE.context.set("persona", resolvedPersona);

                    //update mtag ude
                    this.LE.lpTagAddVar([
                        {name: "ActivePersona", val: resolvedPersona}
                    ]);
                    var module = this.LE.module(options.moduleName);
                    if (module) {
                        this.LE.context.set("activeModuleName", options.moduleName);
                        this.LE.context.setDisplayedModule(options.moduleName);

                        // Set lockers on Reporting and connectionbar is needed
                        this.LE.vent.trigger(CONST.EVENTS.REPORTING_DASHBOARD_LOCKING, _.result(module, "lockReporting"));
                    }

                    //TODO: set persona in session manager.
                    if (region.switcherControl) {
                        this.liveEngageUserBarController.setViewedWorkarea("." + region.switcherControl);
                    }
                }
            }, this);
            this.LE.vent.on("onPersonaSwitcher:onSwitch", function (eventData) {
                //Map Persona items to their modules
                if (eventData.switchedPersona && this.LE.moduleManager.hasPersona(eventData.switchedPersona)) {
                    var personaModule = this.LE.moduleManager.resolveModuleName(eventData.switchedPersona);
                    var module = this.LE.module(personaModule);
                    if (module) {
                        module.router.switchModule({backBrowser: eventData.backBrowser});
                    }
                }
            }, this);
            //this.LE.vent.on("module:started", this.setModuleMainView, this);

            //show the main layout in the main region
            this.LE.mainRegion.show(this.mainLayout);

            var personas = this.LE.sessionManager.getPersonas();

            if (this.LE.sessionManager.isAuthenticated()) {
                var hasLiveEngageTagPrivileges = this.LE.sessionManager.hasPrivilege([this.LE.sessionManager.PRIVILEGES.LE_VIEW_CAMPAIGN_MODULE, this.LE.sessionManager.PRIVILEGES.LE_VIEW_USER_MANAGEMENT_MODULE], true);
                this.addMyProfileTopLevelMenuItem(); //TODO: should enable when link is ready
                this.addMyAccountTopLevelMenuItem();
                if (hasLiveEngageTagPrivileges && !LE.siteSettings.customizationSettings.isHideLeTagPage()) {
                    this.addLiveEngageTagTopLevelMenuItem();
                }

                this.addAuditTrailMenuItem();
                this.addMyShiftStatusMenuItem();
                this.addStatusPageMenuItem();

//                if ((_.contains(personas, this.LE.sessionManager.PERSONA.ADMIN) || _.contains(personas, this.LE.sessionManager.PERSONA.MARKETER))){
//                    this.addDataSourcesTopLevelMenuItem();
//                }
                // remove the upgradeAccount until the links are ready
                // if isLPA && hasMigratingFeature && isAdministrator display 'upgradeAccount item'
                if (!LE.sessionManager.hasLiveEngage2Feature() && this.LE.sessionManager.hasMigratingFeature() &&
                    (this.LE.sessionManager.isLPA() || this.LE.sessionManager.isAdmin())) {
                    this.addUpgradeAccountTopLevelMenuItem();
                } else { // call to the isTrial API only if we are authenticated
                    this.LE.BillingInformation(false);
                }
            }

        },

        _setRegions: function () {
            //set each module main view in the correct region
            _.each(this.LE.moduleManager.moduleRegions, this._setModuleMainView, this);
        },

        _setModuleMainView: function (regionId, moduleName, modules) {
            var delayedStart = false;

            if (!moduleName) {
                delayedStart = true;
                moduleName = regionId.moduleName;
                regionId = this.LE.moduleManager.moduleRegions[moduleName];
            }

            //get the main view from the module and set it in the region
            var module = this.LE.module(moduleName);

            if (module && module.startWithParent || delayedStart) {
                this.LE.vent.trigger("module:before:render", {moduleName: moduleName, regionId: regionId});

                var view = _.result(module, "getMainView");
                if (view) {
                    this.mainLayout[regionId].show(view);
                    this.LE.vent.trigger("LERegion:" + moduleName + ":ready", {
                        moduleName: moduleName,
                        region: this.mainLayout[regionId]
                    }); // fired the event informing that the layout(DOM) is ready
                }
            }
        },

        addLiveEngageTagTopLevelMenuItem: function () {
            this.LE.menuItems.LiveEngageTag = new TopLevelMenuItemModel({
                title: this.LE.translator.translate("LEFramework.LiveEngageTag.title"),
                callback: this.displayLpTagviewDialog,
                iconClass: "live-engage-icon",
                context: this,
                enabled: true
            });
            this.LE.userBarMenu.addMenuItem(this.LE.menuItems.LiveEngageTag, 0);
        },

        addMyProfileTopLevelMenuItem: function () {
            if (this._shouldDisplayMyProfileButton()) {
                this.LE.menuItems.MyProfile = new TopLevelMenuItemModel({
                    title: this.LE.translator.translate("LEFramework.userBarMenu.item.myDetails"),
                    callback: this.displayMyProfileView,
                    iconClass: "my-profile-icon",
                    context: this,
                    enabled: true
                });
                this.LE.userBarMenu.addMenuItem(this.LE.menuItems.MyProfile, 0);
            }
        },

        addMyAccountTopLevelMenuItem: function () {
            var hasLEMyAccount = LE.sessionManager.hasLEMyAccount();
            var allowUserAccess = LE.sessionManager.hasLiveEngage2Feature() && LE.sessionManager.hasPrivilege(LE.sessionManager.PRIVILEGES.ACCOUNT_BILLING);
            if (hasLEMyAccount && allowUserAccess) {
                this.LE.menuItems.MyAccount = new TopLevelMenuItemModel({
                    title: this.LE.translator.translate("LEFramework.userBarMenu.item.myAccount"),
                    callback: this.displayMyAccountView,
                    iconClass: "my-account-icon",
                    context: this,
                    enabled: true
                });
                this.LE.userBarMenu.addMenuItem(this.LE.menuItems.MyAccount, 0);
            }
        },

        addMyShiftStatusMenuItem: function () {
            //In account that has the messaging property only agent managers and administrators should be able to see this item
            if (LE.sessionManager.getFeatureProperty('Common.Async_Messaging') && LE.sessionManager.getFeatureProperty('Common.Async_Messaging').value &&
                LE.sessionManager.getFeatureProperty('Common.Async_Messaging').value.value &&
                LE.sessionManager.hasPrivilege(LE.sessionManager.PRIVILEGES.CONFIGURE_SHIFT_STATUS)) {
                this.LE.menuItems.ShiftStatus = new TopLevelMenuItemModel({
                    title: this.LE.translator.translate("LEFramework.userBarMenu.item.workingHours"),
                    callback: this.displayShiftStatusView,
                    iconClass: "shift-status-icon",
                    context: this,
                    enabled: true
                });
                this.LE.userBarMenu.addMenuItem(this.LE.menuItems.ShiftStatus, 0);
            }
        },

        addStatusPageMenuItem: function () {
            if (LE.sessionManager.hasPrivilege(LE.sessionManager.PRIVILEGES.VIEW_STATUS_PAGE)) {
                this.LE.menuItems.StatusPageLink = new TopLevelMenuItemModel({
                    title: this.LE.translator.translate("LEFramework.userBarMenu.item.statusPage"),
                    callback: this.openStatusPage,
                    iconClass: "status-page-icon",
                    context: this,
                    enabled: true
                });
                this.LE.userBarMenu.addMenuItem(this.LE.menuItems.StatusPageLink, 0);
            }
        },

        addAuditTrailMenuItem: function () {
            if (LE.sessionManager.hasAuditTrailFeature() && LE.sessionManager.hasPrivilege(LE.sessionManager.PRIVILEGES.VIEW_AUDIT_TRAIL)) {
                this.LE.menuItems.AuditTrail = new TopLevelMenuItemModel({
                    title: this.LE.translator.translate("LEFramework.userBarMenu.item.auditTrail"),
                    callback: this.displayAuditTrailView,
                    iconClass: "audit-trail-icon",
                    context: this,
                    enabled: true
                });
                this.LE.userBarMenu.addMenuItem(this.LE.menuItems.AuditTrail, 0);
            }
        },

        _shouldDisplayMyProfileButton: function () {
            return (!this.LE.sessionManager.isLPA() && LE.sessionManager.hasPrivilege(LE.sessionManager.PRIVILEGES.CHANGE_MY_DETAILS));
        },

        buildActivateAccountTrayItem: function () {
            var trayItem = new TrayMenuItemModel({
                type: "text",
                text: this.LE.translator.translate("LEFramework.userBarMenu.menuItemTray.ActivateAccount"),
                trayItemTextClass: ".tray-menu-item-text",
                dataItem: "migration-mode",
                callback: null,
                bubbleComponentId: "bubbleUpgradeAccount",
                withBubble: true,
                bubbleTargetControl: ".tray-menu-item-text",
                bubbleText: "",
                bubblePosition: Bubble.POSITION.BOTTOM,
                bubbleIcon: "",
                bubbleShowCloseButton: true,
                bubbleTitle: "",
                bubblePermutation: Bubble.PERMUTATION.C,
                bubbleContentView: new UpgradeAccountView({}),
                bubbleButtonCallback: undefined,
                bubbleCloseOutsideClick: false,
                index: 4
            });

            return trayItem;
        },

        addUpgradeAccountTopLevelMenuItem: function () {
            this.LE.menuItems.activateAccount = this.buildActivateAccountTrayItem();
            this.LE.userBarMenu.addTrayItem(this.LE.menuItems.activateAccount, 0);
        },

        displayLpTagviewDialog: function () {
            LE.crossModule("manager", LE.mediaCodes.manager.redirects.lptag);
        },

        displayMyProfileView: function () {
            LE.crossModule("manager", LE.mediaCodes.manager.redirects.myProfile);
        },

        displayMyAccountView: function () {
            LE.crossModule("registration", LE.media.actions.command, LE.mediaCodes.registration.commands.accountSettings);
        },

        displayShiftStatusView: function () {
            LE.crossModule("manager", LE.mediaCodes.manager.redirects.shiftStatus);
        },

        displayAuditTrailView: function () {
            LE.crossModule("manager", LE.mediaCodes.manager.redirects.auditTrail);
        },

        openStatusPage: function () {
            var statusUrl = LEResourceResolver.getUrl(LEResourceResolver.apiResources.ServiceStatusDashboard.HealthPage);
            LE.navigator.open(statusUrl, 'service_status_dashboard');
        }

    });

    return LiveEngageLayoutController;
});
